import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { api_url } from '../../../js_assets/ConfigApp';
import { GetApi, PostApi } from '../../../js_assets/Network';
import { getParameterByName } from '../../../js_assets/getParameterByName'

import Dialog from '@material-ui/core/Dialog';


import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios'
import AppAdminContainer from '../AppAdminContainer'
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
function Transition(props) {
    return <Slide direction="up" {...props} />;
}


const styles = theme => ({
    input: {
        paddingRight: 10,
        flex: 1,
    },
    divpadding: {
        padding: '5%'
    },
    btn_login: {
        color: 'white',
        padding: '10px 1px',
        border: 'none',
        cursor: 'pointer',
        width: '100%',
        opacity: '0.9',
        borderRadius: '3px',

    },
    btn_Resetfrom: {

        color: 'white',
    }
});

class FormOffers extends Component {

    constructor(props) {
        super(props);
        this.state = {

            loading_Save: false,
            offer_Id: 0,
            successmessage: false,
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
        };
    }



    componentDidMount() {



        let offer_Id = getParameterByName("offer_Id")


        if (offer_Id !== null) {

            if (offer_Id === "New") {

                //console.log("it new ")
            } else {

                //console.log("it number " + offer_Id)

                axios.get(`${api_url}/api/offer/GetOffer/${offer_Id}`)
                    .then(result => {

                        //console.log(result.data);

                        this.setState({ offer_Id: result.data.offer_Id })
                        this.refs.offer_StoreName.value = result.data.offer_StoreName;
                        this.refs.offer_Code.value = result.data.offer_Code;
                        this.refs.offer_Description.value = result.data.offer_Description;
                        this.refs.offer_Image.value = result.data.offer_Image;
                        this.refs.offer_Date.value = result.data.offer_Date;
                        this.refs.code_Remaining.value = result.data.code_Remaining

                    })
            }

        }



    }




    Save_Offer = (e) => {


        e.preventDefault();
        this.setState({ loading_Save: true });

        const { Admin_Info } = this.state;

        var data = new FormData();

        if (this.refs.ImageUP.files.length !== 0) {


            data.append("UploadedImage", this.refs.ImageUP.files[0]);
            axios.post(`${api_url}/api/offer/SaveImageOffer`, data, { headers: { 'Content-type': 'application/json; charset=utf-8' } })
                .then(result => {


                    let offerData = {
                        admin_Id: parseInt(Admin_Info.admin_Id),
                        offer_Id: parseInt(this.state.offer_Id),
                        offer_StoreName: this.refs.offer_StoreName.value,
                        offer_Code: this.refs.offer_Code.value,
                        offer_Description: this.refs.offer_Description.value,
                        offer_Image: result.data,
                        code_Remaining: parseInt(this.refs.code_Remaining.value)

                    }



                    PostApi(`/api/Admin/Save_Advertising/${Admin_Info.admin_Id}`, offerData, Admin_Info.jwT_Token_Admin)
                        .then(() => {

                            this.setState({ loading_Save: false, successmessage: true });
                            //console.log("it update ")
                        })


                })
                .catch(function (error) {
                    //console.log(error);
                });



        } else {

            let offerData = {
                admin_Id: parseInt(Admin_Info.admin_Id),
                offer_Id: parseInt(this.state.offer_Id),
                offer_StoreName: this.refs.offer_StoreName.value,
                offer_Code: this.refs.offer_Code.value,
                offer_Description: this.refs.offer_Description.value,
                offer_Image: this.refs.offer_Image.value,
                offer_Date: new Date(Date.parse(this.refs.offer_Date.value)),
                code_Remaining: parseInt(this.refs.code_Remaining.value)

            }

            PostApi(`/api/Admin/Save_Advertising/${Admin_Info.admin_Id}`, offerData, Admin_Info.jwT_Token_Admin)
                .then(() => {

                    this.setState({ loading_Save: false, successmessage: true });


                })


        }










    }

    handlClosesuccessmessage = () => {
        this.setState({ successmessage: false })
    }

    render() {
        const { classes } = this.props;
        const { loading_Save } = this.state;


        return (

            <AppAdminContainer Title={"العروض"}>
                <Dialog
                    open={this.state.successmessage}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handlClosesuccessmessage}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="alertIcon">✔️ <label>تم حفظ </label></div>
                    </DialogTitle>


                </Dialog>

                <form onSubmit={this.Save_Offer} acceptCharset={"multipart/form-data"}>

                    <input ref="offer_Id" value={this.state.offer_Id} />




                    <div >
                        <i className="fa-icon"> اسم المتجر</i>
                        <input placeholder="اسم المتجر" name="offer_StoreName" ref="offer_StoreName" required />
                    </div>

                    <div >
                        <i className="fa-icon"> كود الخصم</i>
                        <input placeholder="كود الخصم " name="offer_Code" ref="offer_Code" required />
                    </div>

                    <div >
                        <i className="fa-icon"> عدد الاكواد</i>
                        <input placeholder=" عدد الاكواد " name="code_Remaining" ref="code_Remaining" required />
                    </div>
                    {this.state.offer_Id !== 0 ?

                        <div >
                            <i className="fa-icon">  تاريخ الاعلان</i>
                            <input placeholder=" " name="offer_Date" ref="offer_Date" required />
                        </div>


                        : null}

                    <div >

                        <textarea rows={5} placeholder="وصف العرض" name="offer_Description" ref="offer_Description" required />
                    </div>
                    <input ref="offer_Image" /><br></br>
                    <label>صورة </label><br></br>
                    <input type="file" ref='ImageUP' accept="image/*" name="fileInput" />
                    <div >
                        <button variant="contained" type="Submit" color="primary" className={classes.btn_login}  >
                            {loading_Save === true ? <CircularProgress color={"secondary"} /> : <label>حفظ</label>}

                        </button>

                    </div>

                </form>

            </AppAdminContainer >




        )
    }


}
FormOffers.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FormOffers);